export default __webpack_public_path__ + "images/95cd320d475150775fd0e00bc88bdc24-Industry-Bold.woff";